export type AuxiliaryQueryKeyPart = string | number | boolean | null;

export type AuxiliaryQueryKey = readonly [
  "auxiliary",
  string,
  string,
  ...ReadonlyArray<AuxiliaryQueryKeyPart>,
];

export interface SceneSummariesKeyInput {
  baseUrl: string;
  scenarioId: string;
  page: number;
  pageSize: number;
}

export interface StatsKeyInput {
  baseUrl: string;
  resource: string;
  filter?: string;
  pageSize?: number;
}

export interface ScenarioKeyInput {
  baseUrl: string;
  scenarioId: string;
}

export interface MutationEffects {
  update: ReadonlyArray<AuxiliaryQueryKey>;
  invalidate: ReadonlyArray<AuxiliaryQueryKey>;
}

export const auxiliaryQueryKeys = {
  sceneSummaries(input: SceneSummariesKeyInput): AuxiliaryQueryKey {
    return [
      "auxiliary",
      "scene-summaries",
      input.baseUrl,
      input.scenarioId,
      input.page,
      input.pageSize,
    ];
  },

  stats(input: StatsKeyInput): AuxiliaryQueryKey {
    return [
      "auxiliary",
      "stats",
      input.baseUrl,
      input.resource,
      input.filter ?? null,
      input.pageSize ?? null,
    ];
  },

  spawnedFrom(input: ScenarioKeyInput): AuxiliaryQueryKey {
    return ["auxiliary", "spawned-from", input.baseUrl, input.scenarioId];
  },

  feedbackSignal(input: ScenarioKeyInput): AuxiliaryQueryKey {
    return ["auxiliary", "feedback-signal", input.baseUrl, input.scenarioId];
  },

  feedbackSnapshots(input: ScenarioKeyInput): AuxiliaryQueryKey {
    return ["auxiliary", "feedback-snapshots", input.baseUrl, input.scenarioId];
  },

  feedbackLoopConfig(input: ScenarioKeyInput): AuxiliaryQueryKey {
    return [
      "auxiliary",
      "feedback-loop-config",
      input.baseUrl,
      input.scenarioId,
    ];
  },
};

export const auxiliaryMutationEffects = {
  feedbackLoopConfig(input: ScenarioKeyInput): MutationEffects {
    return {
      update: [auxiliaryQueryKeys.feedbackLoopConfig(input)],
      invalidate: [
        auxiliaryQueryKeys.feedbackSignal(input),
        auxiliaryQueryKeys.feedbackSnapshots(input),
      ],
    };
  },
};
